import(/* webpackMode: "eager" */ "/var/www/light_of_empire_front/widgets/Cookie/Cookie.tsx");
